import React from 'react'
import { TabsWrapper, Tab } from '../styles'

type Props = {
  tabs: Array<string>
  selectedTab: number
  handleTabChange: (index: number) => void
}

const Tabs = ({ tabs, handleTabChange, selectedTab }: Props) => (
  <TabsWrapper justify="center">
    {tabs.map((tab, index) => (
      <Tab
        onClick={() => handleTabChange(index)}
        key={tab}
        selected={selectedTab === index}>
        {tab}
      </Tab>
    ))}
  </TabsWrapper>
)

export default Tabs
